// Material UI
import {Avatar, IconButton} from '@mui/material';

type UserAvatarProps = {
  alt: string;
  avatarUrl: string;
  onClick: (event: any) => void;
};

export default function UserAvatar(props: UserAvatarProps) {
  return (
    <IconButton
      onClick={props.onClick}
      sx={{
        p: 0,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
        },
      }}
    >
      <Avatar alt={props.alt} src={props.avatarUrl} />
    </IconButton>
  );
}
